import { FC } from 'react'

const ImageReccomendedDimentionsMessage: FC<{ size?: string }> = ({ size }) => {
    return (
        <>
            <strong>Image size:</strong> The recommended image dimenssions is
            {size || '1920 x 1280 pixels'}
        </>
    )
}

export default ImageReccomendedDimentionsMessage
